export default __webpack_public_path__ + "static/media/cdetb-logo-full-bg.3aaf1ace.png";